module.exports = "  <!--Agenda do usuário-->\r\n<div id=\"onContactScreen\" class=\"cellphone-page-usuarios\">\r\n\t<h1 class=\"text-white text-center pb-2\">{{name}}</h1>\r\n <!-- Perfil do usuário-->\r\n \t<div class=\"cellphone-page-unit\" id=\"contactList\" >\r\n\t\t<iframe id=\"cellFrame\" [src]=\"frame | safe\"\r\n\t\tstyle=\"height:100%;width:100%;\"></iframe>\r\n\r\n\t</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/cellphone-modal/iframe-screen/iframe-screen.html
// module id = ../../../../../src/app/components/+gameevent/cellphone-modal/iframe-screen/iframe-screen.html
// module chunks = main